import React from 'react';

export default () => <h3>404</h3>;
